"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./RepositoryOwnerPanelAssignmentAndClassification.scss");
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _ConditionalErrorMessage = require("./ConditionalErrorMessage");
var _ClassificationOptionLabelWithTooltip = _interopRequireDefault(require("./ClassificationOptionLabelWithTooltip"));
var _ArtifactTagOptions = require("../Shared/Models/ArtifactTagOptions");
var _Shared = require("../Shared");
var _LoadingShimmer = _interopRequireDefault(require("../Shared/Components/LoadingShimmer"));
var _RepoPanelServiceTreePicker = _interopRequireDefault(require("./Assignment/AssignmentSection/RepoPanelServiceTreePicker"));
var _AssignmentSection = _interopRequireDefault(require("./Assignment/AssignmentSection/AssignmentSection"));
var _ReadonlyAssignedServices = _interopRequireDefault(require("./Assignment/AssignmentSection/ReadonlyAssignedServices"));
var _ReadonlyDirectOwners = _interopRequireDefault(require("./Assignment/AssignmentSection/ReadonlyDirectOwners"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var RepositoryOwnerPanelAssignmentAndClassification = function RepositoryOwnerPanelAssignmentAndClassification(props) {
  var _props$ownerPickerPro, _props$ownerPickerPro2, _props$ownerPickerPro3;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    initialClassification = _React$useState2[0],
    setInitialClassification = _React$useState2[1];
  React.useEffect(function () {
    if (initialClassification === undefined && (props.classification === _ArtifactTagOptions.ArtifactTagOptions.PRODUCTION || props.classification === _ArtifactTagOptions.ArtifactTagOptions.NONPRODUCTION)) {
      setInitialClassification(props.classification);
    }
  }, [initialClassification, props.classification]);
  if (props.isLoading) {
    return /*#__PURE__*/React.createElement(_LoadingShimmer.default, null);
  }
  var ProductionOption = {
    id: "choice-option-prod",
    key: _ArtifactTagOptions.ArtifactTagOptions.PRODUCTION,
    ariaLabel: t("repositoryOwnerPanel.classification.production"),
    text: t("repositoryOwnerPanel.classification.production"),
    onRenderLabel: function onRenderLabel() {
      return /*#__PURE__*/React.createElement(ProductionRender, _extends({
        isSelected: props.classification === _ArtifactTagOptions.ArtifactTagOptions.PRODUCTION
      }, props));
    }
  };
  var NonProductionOption = {
    id: "choice-option-non-prod",
    key: _ArtifactTagOptions.ArtifactTagOptions.NONPRODUCTION,
    ariaLabel: t("repositoryOwnerPanel.classification.nonProduction"),
    text: t("repositoryOwnerPanel.classification.nonProduction"),
    onRenderLabel: function onRenderLabel() {
      return /*#__PURE__*/React.createElement(NonProductionRender, _extends({
        isSelected: props.classification === _ArtifactTagOptions.ArtifactTagOptions.NONPRODUCTION
      }, props));
    }
  };
  return /*#__PURE__*/React.createElement(_react2.Stack, {
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React.createElement(_ConditionalErrorMessage.ConditionalErrorMessage, {
    error: props.classificationError
  }), /*#__PURE__*/React.createElement(_ConditionalErrorMessage.ConditionalErrorMessage, {
    error: props.assignmentError
  }), initialClassification === _ArtifactTagOptions.ArtifactTagOptions.PRODUCTION && ((_props$ownerPickerPro = props.ownerPickerProps.defaultArtifactOwnership) === null || _props$ownerPickerPro === void 0 ? void 0 : (_props$ownerPickerPro2 = _props$ownerPickerPro.owners) === null || _props$ownerPickerPro2 === void 0 ? void 0 : _props$ownerPickerPro2.length) > 0 && /*#__PURE__*/React.createElement(_react2.MessageBar, {
    messageBarType: _react2.MessageBarType.severeWarning
  }, "This repository is directly owned by ".concat((_props$ownerPickerPro3 = props.ownerPickerProps.defaultArtifactOwnership) === null || _props$ownerPickerPro3 === void 0 ? void 0 : _props$ownerPickerPro3.owners.join(' and '), " and classified as Production. We no longer support direct ownership for Production repos. Please re-assign this repository to a Service.")), /*#__PURE__*/React.createElement(_react2.ChoiceGroup, {
    disabled: props.disabled,
    selectedKey: props.classification,
    onChange: function onChange(ev, option) {
      if (option) {
        props.setClassification(option.key);
      }
    },
    options: [ProductionOption, NonProductionOption]
  }));
};
var ProductionRender = function ProductionRender(props) {
  if (props.classification === _ArtifactTagOptions.ArtifactTagOptions.PRODUCTION && !props.isAssignmentReadonly) {
    props.setOwnerType(_Shared.OwnerType.SERVICE);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_ClassificationOptionLabelWithTooltip.default, {
    labelText: t("repositoryOwnerPanel.classification.production"),
    tooltipText: t("repositoryOwnerPanel.classification.productionSubtitle")
  }), props.isSelected && (props.isAssignmentReadonly ? /*#__PURE__*/React.createElement("div", {
    className: "classification-subsection"
  }, /*#__PURE__*/React.createElement("div", null, props.ownerType === _Shared.OwnerType.SERVICE && /*#__PURE__*/React.createElement(_ReadonlyAssignedServices.default, {
    defaultProducts: props.serviceTreePickerProps.defaultProducts
  }), props.ownerType === _Shared.OwnerType.PERSON && /*#__PURE__*/React.createElement(_ReadonlyDirectOwners.default, {
    artifactOwnership: props.ownerPickerProps.defaultArtifactOwnership
  }))) : /*#__PURE__*/React.createElement(_RepoPanelServiceTreePicker.default, {
    ownerType: props.ownerType,
    serviceTreePickerProps: props.serviceTreePickerProps
  })));
};
var NonProductionRender = function NonProductionRender(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_ClassificationOptionLabelWithTooltip.default, {
    labelText: t("repositoryOwnerPanel.classification.nonProduction"),
    tooltipText: t("repositoryOwnerPanel.classification.nonProductionSubtitle")
  }), props.isSelected && /*#__PURE__*/React.createElement("div", {
    className: "classification-subsection"
  }, /*#__PURE__*/React.createElement(_AssignmentSection.default, {
    ownerType: props.ownerType,
    setOwnerType: props.setOwnerType,
    serviceTreePickerProps: props.serviceTreePickerProps,
    ownerPickerProps: props.ownerPickerProps,
    error: props.assignmentError,
    isLoading: props.isLoading,
    isReadonly: props.isAssignmentReadonly,
    isSubmitting: props.isSubmitting
  })));
};
var _default = RepositoryOwnerPanelAssignmentAndClassification;
exports.default = _default;